import { render, staticRenderFns } from "./Treatments.vue?vue&type=template&id=2eadf9de&scoped=true&"
import script from "./Treatments.vue?vue&type=script&lang=js&"
export * from "./Treatments.vue?vue&type=script&lang=js&"
import style0 from "./Treatments.vue?vue&type=style&index=0&id=2eadf9de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eadf9de",
  null
  
)

export default component.exports